import * as React from 'react';

import { useToastStore } from '@/stores';

import { Toast } from './ToastItem';

const ToastContainer = () => {
    const toasts = useToastStore((s) => s.toasts);

    return (
        <section
            aria-live="polite"
            aria-label="Notifications"
            className="pointer-events-none fixed left-1/2 top-4 z-50 flex -translate-x-1/2 flex-col gap-2"
        >
            {toasts.map((t) => (
                <div key={t.id} className="pointer-events-auto">
                    <Toast toast={t} />
                </div>
            ))}
        </section>
    );
};

ToastContainer.displayName = 'ToastContainer';

export { ToastContainer };
